import React from "react";

const About = () => {
    return (
        <div>
            <h1>À propos</h1>
            <br />
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore
                perferendis similique, iusto laboriosam odit facilis animi hic
                magni aliquam vel minima pariatur maxime illo dicta mollitia
                quos distinctio recusandae vitae assumenda rerum saepe, officiis
                sed eum. Unde, corporis? Ipsam ullam natus omnis, laudantium in
                voluptatum tenetur sequi repellendus cumque rerum repellat?
                Molestiae illum eos incidunt fugiat, deleniti autem. Consectetur
                sunt delectus facere odio quam porro veritatis aliquam quae esse
                inventore sed nemo pariatur dignissimos recusandae consequuntur
                dolor laborum beatae ut a, vero cum suscipit unde accusamus! Aut
                qui vero rem unde dolores at optio, consequatur accusamus
                eligendi facere cupiditate omnis?
            </p>
            <br />
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Inventore perferendis libero tempora, minima quo quia suscipit
                quibusdam et, repellat consectetur iure mollitia aliquid
                praesentium consequuntur necessitatibus dignissimos beatae
                porro? Sunt quod similique error laudantium provident quasi aut
                cumque. Autem, officia. Officiis odit ratione aliquam sequi,
                aspernatur praesentium maxime harum error!
            </p>
        </div>
    );
};

export default About;
